
<div class="wizard-container">
  <!-- Heading -->
<header class="wizard-header" role="banner" aria-label="Price Rate Request Form">
    <h1 class="wizard-title">Price Quote Request</h1>
</header>
<!-- contact screen -->
  <app-contact-info-form #contactInfoForm [formGroup]="contactForm" (next)="goToStep(2)" (resetAction)="clearAction()" [hidden]="currentStep !== 1"></app-contact-info-form>
<!-- shipment screen -->
  <app-shipment-details-form #shipmentDetailsForm [formGroup]="shipmentForm" (back)="goToStep(1)" (submitFinal)="submitForm()" (resetAction)="clearAction()" [hidden]="currentStep !== 2"></app-shipment-details-form>
</div>




